import CleaningIcon from '../Images/cleaning-icon.svg'
 
 
 
 const homeCleaning = [
    {
        id: 1, 
        image: CleaningIcon,
        option: 'Studio Flat',
        desc: 'Entire Studio Apartment, Kitchen & Appliances, Bathroom & Toilet, Deep Carpet Cleaning'  
    }, 
    
    {
        id: 2, 
        image: CleaningIcon,
        option: '1 Bedroom Flat',
        desc: '1 Bedroom, 1 Bathroom, 1 Kitchen, 1 Living room, 1 Hallaway, Deep Carpet Cleaning, Kitchen Appliances'  
    },
    {
        id: 3, 
        image: CleaningIcon,
        option: '2 Bedroom Flat',
        desc: '2 Bedroom,1 Bathroom, 1 Kitchen, 1 Living room,1 Hallaway, Deep Carpet Cleaning, Kitchen Appliances'
    },{
        id: 5, 
        image: CleaningIcon,
        option: '3 Bedroom Flat',
        desc: ''  
    },{
        id: 6, 
        image: CleaningIcon,
        option: '4 Bedroom Flat',
        desc: ''  
    },{
        id: 7, 
        image: CleaningIcon,
        option: '5 Bedroom Flat',
        desc: ''  
    },{
        id: 8, 
        image: CleaningIcon,
        option: '6 Bedroom Flat',
        desc: '6 Bedroom, 1 Bathroom, 1 Kitchen, 1 Living room,1 Hallaway, Deep Carpet Cleaningm, Kitchen Appliances'  
    },{
        id: 9, 
        image: CleaningIcon,
        option: '7 Bedroom Flat',
        desc: '7 Bedroom, 1 Bathroom, 1 Kitchen, 1 Living room,1 Hallaway, Deep Carpet Cleaningm, Kitchen Appliances'  
    },{
        id: 10, 
        image: CleaningIcon,
        option: '8 Bedroom Flat',
        desc: '8 Bedroom, 1 Bathroom, 1 Kitchen, 1 Living room, 1 Hallaway, Deep Carpet Cleaningm, Kitchen Appliances'  
    },
]







export default homeCleaning;